module.exports = __webpack_public_path__ + "assets/img/bg_tu.b572d145.png";